// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"logoComponent_logoContainer__0aIeb","logo":"logoComponent_logo__G0EDb"};